import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  planList: [],
  device: {
    id: null,
    name: '',
    macAddress: '',
    masterId: null,
    masterMacAddress: '',
  },
};

const deviceSlice = createSlice({
  name: 'device',
  initialState,
  reducers: {
    initialize: (state, { payload }) => {
      state[payload] = initialState[payload];
    },
    changeProp: (state, { payload: { obj, key, value } }) => {
      if (obj) {
        state[obj][key] = value;
        return;
      }
      state[key] = value;
    },
  },
});

export const { initialize, changeProp } = deviceSlice.actions;

export default deviceSlice.reducer;
